import { FilledButtonStyled } from './filled-button.cp.styled';

// color: 'default' | 'success' | 'danger'
export const FilledButton = ({ color = 'default', ...rest }) => <FilledButtonStyled $color={color} {...rest} />;
